exports.ById = {
  1: { Id: 1, Name: 'internal_local_file_report_value.pending' },
  2: { Id: 2, Name: 'internal_local_file_report_value.generated' },
  3: { Id: 3, Name: 'internal_local_file_report_value.failed' },
  4: { Id: 4, Name: 'internal_local_file_report_value.uploaded' },
  5: { Id: 5, Name: 'internal_local_file_report_value.converting' }
};

exports.ByName = {
  Pending: { Id: 1, Name: 'internal_local_file_report_value.pending' },
  Generated: { Id: 2, Name: 'internal_local_file_report_value.generated' },
  Failed: { Id: 3, Name: 'internal_local_file_report_value.failed' },
  Uploaded: { Id: 4, Name: 'internal_local_file_report_value.uploaded' },
  Converting: { Id: 5, Name: 'internal_local_file_report_value.converting' }
};
